<template>
  <div class="success-container">
    <p>您的passport账号绑定成功</p>
    <img src="@/assets/img/37d894fa92af9ee1e970a97e5f7a6054.jpg" alt width="100" />
  </div>
</template>

<script>
export default {
  name: "Already",
  data() {
    return {};
  },
  methods: {},
  computed: {},
  created() {}
};
</script>

<style lang="scss" scoped>
.success-container {
  text-align: center;
}
p {
  padding: 50px 0;
  color: #3f51b5;
  font-size: 28px;
}
</style>

